import { useQuery } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import {
	REMINDER_SORT_BY,
	REMINDER_SORT_DIRECTION,
	VISIBLE_REMINDER_STATUSES,
} from "web_myplann/Api/Reminders/remindersListParams";
import { selectReminders } from "web_myplann/Api/Reminders/selectReminders";
import { getPropertyPropertyIdRemindersV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyRemindersListQuery = (propertyId: number) =>
	useQuery({
		queryKey: RemindersKeys.propertyList(propertyId),
		queryFn: processResponseQuery(() =>
			getPropertyPropertyIdRemindersV2(
				propertyId,
				VISIBLE_REMINDER_STATUSES,
				REMINDER_SORT_BY,
				REMINDER_SORT_DIRECTION,
			),
		),
		select: selectReminders,
	});
